import { oc } from '@orpc/contract';
import { userSummarySchema } from '../schemas/auth.schemas.js';
export const getMeContract = oc
    .route({
    method: 'GET',
    path: '/auth/me',
    tags: ['Auth'],
    summary: 'Return the user identified by the bearer access token',
})
    .output(userSummarySchema);
//# sourceMappingURL=get-me.contract.js.map